import { render } from "./saleOderList.vue?vue&type=template&id=1787e8c2"
import script from "./saleOderList.vue?vue&type=script&lang=js"
export * from "./saleOderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__